import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function AddDealModal({ show, setShow }) {

  const [dealName, setDealName] = useState("");
  const [value, setValue] = useState("");

  const handleSave = () => {
    console.log({
      dealName,
      value,
    });

    setShow(false); // close modal
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Deal</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Deal Name</Form.Label>
            <Form.Control
              type="text"
              value={dealName}
              onChange={(e) => setDealName(e.target.value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Value</Form.Label>
            <Form.Control
              type="number"
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={() => setShow(false)}>
          Cancel
        </Button>

        <Button className="btn-orange" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}